LocalStorageModel = require 'view-models/internal/local-storage-model'

module.exports = class CalendarViewState extends LocalStorageModel
  default: ->
    mode: 'month'

  getMode: -> @get('mode')
  setMode: (mode) -> @update('mode', mode)



// WEBPACK FOOTER //
// ./app/scripts/view-models/calendar-view-state.coffee